import { Badge, Loader } from "@mantine/core";

interface CurrentCoordinatesProps {
    /** Coordinates text; omitted in drawing mode, leaving only the loading indicator. */
    coords?: string;
    /** Map data is still loading. */
    loading: boolean;
}

/** Top-left map badge: the center coordinates, with a throbber while map data loads. */
const CurrentCoordinates: React.FC<CurrentCoordinatesProps> = ({ coords, loading }) => {
    if (!coords && !loading) return null;
    return (
        <Badge
            color='black'
            size='lg'
            leftSection={loading && <Loader size={12} color='white' aria-label='Loading map data' />}
            style={{ position: 'absolute', top: 70, left: 20, opacity: 0.8 }}
        >
            {coords ?? 'Loading'}
        </Badge>
    );
}

export default CurrentCoordinates;
